
import * as delivery from './delivery'
import  mergeCheck from '../mergeCheck'
export default mergeCheck([
    delivery
])

